import { render, staticRenderFns } from "./createGroup.vue?vue&type=template&id=93bb1018&scoped=true&"
import script from "./createGroup.vue?vue&type=script&lang=js&"
export * from "./createGroup.vue?vue&type=script&lang=js&"
import style0 from "./createGroup.vue?vue&type=style&index=0&id=93bb1018&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bb1018",
  null
  
)

export default component.exports